module.exports = __webpack_public_path__ + "static/img/jianyi.771d6f8a.png";